export default __webpack_public_path__ + "463bdbfb28abad0fa6df67a935760d33.woff";